import React, { Suspense, lazy } from "react";
import { useAppSelector } from "store/hooks";
import { clientNameConfig } from "Config/themesConfig";
import Loading from "components/shared/Loading";
import "./r2c/R2CSideBar.scss";
import "./oneLink/OneLinkSideBar.scss";

// Dynamically import components with their CSS
const R2CSideBar = lazy(() => import("./r2c/R2CSideBar"));
const OneLinkSideBar = lazy(() => import("./oneLink/OneLinkSideBar"));

/**
 * Represents the navigation bar component, which dynamically renders
 * different sidebar navigation components depending on the logged-in client's type.
 *
 * The component supports dynamic loading of sidebars and their respective CSS to prevent style conflicts.
 * It also displays a loading indicator while the necessary data and components are being loaded.
 */
const Navbar: React.FC = () => {
  const { userType, loading } = useAppSelector((state) => state.user);
  const { client } = userType;

  if (loading) {
    return <Loading />;
  }

  switch (client.name) {
    case clientNameConfig.R2C:
      return (
        <Suspense fallback={<Loading />}>
          <R2CSideBar />
        </Suspense>
      );
    case clientNameConfig.SN:
      return (
        <Suspense fallback={<Loading />}>
          <OneLinkSideBar />
        </Suspense>
      );
    default:
      // If client is not recognised, show a fallback message, or default sidebar can be shown here.
      return <div>Organisation not recognised</div>;
  }
};

export default Navbar;
